import React, { useEffect, useState } from "react";
import CustomStepper from "../../shared/components/CustomStepper";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setDraft } from "../../app/store/reservationSlice";
import BookingConfirmed from "./components/BookingConfirmed";
import WorkshopAndDate from "../../shared/components/WorkshopAndDate";
import BookingInfo from "./components/BookingInfo";
import CancelBookingButton from "./components/CancelBookingButton";
import HeaderInfo from "../../shared/components/HeaderInfo";
import { useWindowSize } from "../../shared/hooks/useWindowSize";
import SelectedVehicle from "../../shared/components/SelectedVehicle";
import { useLazyGetReservationsQuery } from "../../app/store/api/reservationApi";
import { Box } from "@mui/material";

export default function ReservationPage() {

    const { reservationUuid } = useParams();
    const [ reservation, setReservation ] = useState(null);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { isDesktop, isTablet } = useWindowSize();
    const [fetchReservation] = useLazyGetReservationsQuery();

    // Put user on top of page when navigated to this component
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    useEffect(() => {
        getReservation();
        // eslint-disable-next-line
    }, [reservationUuid]);

    const getReservation = () => {
        fetchReservation(reservationUuid).unwrap()
        .then(data => {
            setReservation(data);
            if (data && data.car) {
                dispatch(setDraft({ car: data.car }));
            }
        })
        .catch((error) => {
            console.error("Error fetching reservation:", error);
            navigate("/");
        });
    }

    return (
        <>
        <Box>
            { (isDesktop || isTablet) && 
                <HeaderInfo />
            }
        </Box>
        <Box className='workshop-page'>           
            <CustomStepper />
            {/* <Car /> */}
            
            <Box className='workshop-page_steps'>

                <BookingConfirmed />
                <Box sx={{ marginBottom: '20px' }}>
                    <SelectedVehicle canEdit={false}/>
                </Box>
                <WorkshopAndDate reservation={reservation} />
                <CancelBookingButton reservationUuid={reservationUuid} />
                <BookingInfo reservation={reservation} />
            </Box>
        </Box>
        </>
    );
}